module.exports = __webpack_public_path__ + "img/cengci.5dfd6ddb.png";